import { React, useState, useEffect } from "react";
import TableComponent from "../../components/Table";
import SearchComponent from "../../components/Search";
import PaginationComponent from "../../components/Pagination";
import registrosMockJson from "../../mock/registros.json";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Code } from "../../components/Code";
import PageContainer from "../../components/PageContainer";
import PageHeaderContainer from "../../components/PageHeaderContainer";
import PageContentContainer from "../../components/PageContentContainer";
import Accordion from "react-bootstrap/Accordion";
import CardComponent from "../../components/Card";
import { ContainerWithSidebar } from "../../components/ContainerWithSidebar";

import { AiOutlineTable } from "react-icons/ai";

import { ContainerTablePageStyle } from "./style";

function Tabela({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
  logOut,
}) {
  const [selectValue, setSelectValue] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectValuesIsModify, setselectValuesIsModify] = useState(false);
  const [registrosFiltrados, setRegistrosFiltrados] = useState([]);
  const [registros, setRegistros] = useState(registrosMockJson);
  const registrosJson = registrosMockJson;

  useEffect(() => {
    let page = currentPage;
    if (selectValuesIsModify) {
      page = 1;
      setCurrentPage(1);
      setselectValuesIsModify(false);
    }

    let filtrados = registros.slice(
      (page - 1) * selectValue,
      +selectValue * page
    );
    setRegistrosFiltrados(filtrados);
    setSelectValue(+selectValue);
  }, [selectValue, registros, currentPage, selectValuesIsModify]);

  function setSelectValueChange(event) {
    setSelectValue(event);
    setselectValuesIsModify(true);
  }

  function filterBySearch(value) {
    let registrosFiltrados = registrosJson.filter(
      (r) =>
        r.nome.toLowerCase().includes(value.toLowerCase()) ||
        r.cod === +value ||
        r.sobrenome.toLowerCase().includes(value.toLowerCase()) ||
        r.email.toLowerCase().includes(value.toLowerCase()) ||
        r.status.toLowerCase().includes(value.toLowerCase())
    );
    setRegistros(registrosFiltrados);
  }

  return (
    <ContainerWithSidebar
      increaseFontSize={increaseFontSize}
      decreaseFontSize={decreaseFontSize}
      HandledarkMode={HandledarkMode}
      isDarkMode={isDarkMode}
      logOut={logOut}
    >
      <PageContainer>
        <PageHeaderContainer
          title="Tabela de Registros"
          icon={<AiOutlineTable />}
        />
        <PageContentContainer>
          <ContainerTablePageStyle>
            <Row>
              <Col>
                <h1>Visualização de registros com tabela</h1>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <h2>Estrutura de Visualização</h2>
                <p>
                  A visualização de registros deverá ser composta por 3 (Três)
                  componentes.
                </p>
                <p>
                  <strong> Componente de Busca</strong> responsável por realizar
                  buscas. Esse componente é composto por um campo input que
                  recebe um texto e deve ser capaz de filtrar os resultados
                  baseado em todas as colunas da tabela.
                </p>
                <p>
                  <strong> Componente Tabela</strong> responsável por exibir os
                  registros, e caso aplicado algum filtro de busca exibir as
                  informações filtradas.
                </p>
                <p>
                  <strong> Componente de Paginação</strong> responsável pela
                  paginação dos registros e controle de visualização por página.
                </p>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <h2>Componente de Busca</h2>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>
                        {`import { React } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { AiOutlineSearch } from "react-icons/ai";
import { SearchStyle } from "./style";

function SearchComponent() {
  return (
    <SearchStyle>
      <InputGroup className="mb-3">
        <InputGroup.Text>
          <AiOutlineSearch />
        </InputGroup.Text>
        <Form.Control placeholder="Filtro por qualquer coluna da tabela..." />
      </InputGroup>
    </SearchStyle>
  );
}

export default SearchComponent;`}
                      </Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>
                        {`import styled from "styled-components";

export const SearchStyle = styled.div\`
         

    input{
        outline: none !important;        
        box-shadow: none !important;            
        
        &:focus{           
            border-bottom: 2px solid var(--verde-primario) !important;
            border: 0px;
            border-radius: 0px;                           
        } 
    }
\`;`}
                      </Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <hr />
                <h2>Componente Tabela</h2>
                <p>
                  Componente Bootstrap Base{" "}
                  <a href="https://react-bootstrap.netlify.app/docs/components/table/#example">
                    Componente Tabela
                  </a>
                </p>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>
                        {`import { React } from "react";
import Table from "react-bootstrap/Table";

import StatusDisplay from "../statusDisplay";

import { RiDeleteBin6Line } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import { BsEye } from "react-icons/bs";

import { TableStyle } from "./style";

function TableComponent() {
  return (
    <TableStyle>
      <div className="table-area">
        <Table hover striped>
          <thead>
            <tr>
              <th>Registro</th>
              <th>Nome</th>
              <th>Sobrenome</th>
              <th>Email</th>
              <th>Status</th>
              <th colSpan="3">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>#334</td>
              <td>João</td>
              <td>Silva</td>
              <td>joao@gmail.com</td>
              <td>
                <StatusDisplay status="Sucesso" />
              </td>
              <td className="action-column">
                <BsEye />
              </td>
              <td className="action-column">
                <CiEdit />
              </td>
              <td className="action-column">
                <RiDeleteBin6Line id="delete-icon" />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </TableStyle>
  );
}

export default TableComponent;`}
                      </Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>
                        {`import styled from "styled-components";

export const TableStyle = styled.div\`
   

  .table-area {
    width: 100%;
    background-color: var(--branco) !important;
  }

  .table {
    tbody {
      tr {
        td {
          border-bottom: none !important;
        }        
      }

      .action-column {
        text-align: center;

        #delete-icon {
          color: var(--vermelho-perigo);
          &:hover {
            color: var(--verde-primario);
            cursor: pointer;
          }
        }

        svg {
          font-size: 24px;
          &:hover {
            color: var(--verde-primario);
            cursor: pointer;
          }
        }
      }
    }
  }

  @media screen and (max-width: 800px) {
    .table-area {
      overflow-y: scroll !important;
    }
  }
\`;`}
                      </Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <hr />
                <h2>Componente de Paginação</h2>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import { React } from "react";
import Form from "react-bootstrap/Form";

import { PaginationStyle } from "./style";
import {
  MdNavigateNext,
  MdNavigateBefore,
  MdLastPage,
  MdFirstPage,
} from "react-icons/md";

function PaginationComponent() {
  return (
    <PaginationStyle>
      <Form.Select className="select-per-page" value="10">
        <option>10</option>
      </Form.Select>
      <div>
        <span>Total de registros: 100</span>
      </div>
      <div className="area-paginacao">
        <div>
          <MdFirstPage />
        </div>
        <div>
          <MdNavigateBefore />
        </div>
        <div>
          <span>1 de 100</span>
        </div>
        <div>
          <MdNavigateNext />
        </div>
        <div>
          <MdLastPage />
        </div>
      </div>
    </PaginationStyle>
  );
}

export default PaginationComponent;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const PaginationStyle = styled.div\`
   

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--cinza-primario);
  background-color: var(--branco);
  border-radius: 5px;
  padding: 0.5rem;

  select {
    outline: none !important;
    box-shadow: none !important;

    &:focus {
      border-bottom: 2px solid var(--verde-primario) !important;
      border: 0px;
    }
  }

  .select-per-page {
    width: 10%;
    min-width: 5rem;
    border-radius: 0 !important;

    &:focus {
      outline: none !important;
    }
  }

  .area-paginacao {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;

    svg {
      font-size: 24px;
      color: var(--preto-primario);

      &:hover {
        color: var(--verde-primario);        
        cursor: pointer;
      }
    }
  }
\`;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <hr />
                <h2>Componente Status Display</h2>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`function StatusDisplay({ status }) {
  function handleColorStatus(value) {
    if (value === "Atenção") return "var(--amarelo-atencao)";
    if (value === "Sucesso") return "var(--verde-sucesso)";
    if (value === "Perigo") return "var(--vermelho-perigo)";
  }

  return (
    <div
      title={status}
      style={{
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: handleColorStatus(status),
      }}
    ></div>
  );
}

export default StatusDisplay;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <h2>Visualização esperada</h2>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <CardComponent
                  title="Informativo!"
                  subTitle="Atenção!"
                  bgColor="info"
                  textColor="white"
                  size="100%"
                >
                  Esta visualização é apenas um exemplo de layout. As colunas e
                  nomes devem ser aptadas conforme a necessidade de cada
                  projeto.
                </CardComponent>
              </Col>
            </Row>
            <Row>
              <Col>
                <SearchComponent filterBySearch={filterBySearch} />
              </Col>
            </Row>
            <Row>
              <Col>
                <TableComponent registros={registrosFiltrados} />
              </Col>
            </Row>
            <Row>
              <Col>
                <PaginationComponent
                  selectValue={selectValue}
                  setSelectValueChange={setSelectValueChange}
                  registrosJson={registros}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </Col>
            </Row>
          </ContainerTablePageStyle>
        </PageContentContainer>
      </PageContainer>
    </ContainerWithSidebar>
  );
}

export default Tabela;
